"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _PasswordField = _interopRequireDefault(require("../../PasswordField"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FormPasswordField = function FormPasswordField(_ref) {
  var register = _ref.register,
      inputProps = _ref.inputProps,
      placeholder = _ref.placeholder,
      name = _ref.name,
      _ref$showPasswordDefa = _ref.showPasswordDefault,
      showPasswordDefault = _ref$showPasswordDefa === void 0 ? false : _ref$showPasswordDefa;

  var _useState = (0, _react.useState)(showPasswordDefault),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showPassword = _useState2[0],
      setShowPassword = _useState2[1];

  var handleClickShowPassword = function handleClickShowPassword() {
    setShowPassword(!showPassword);
  };

  var handleMouseDownPassword = function handleMouseDownPassword(event) {
    event.preventDefault();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordField.default, {
    inputProps: (0, _extends2.default)({}, inputProps, register),
    placeholder: placeholder,
    togglePassword: showPassword,
    name: name,
    onClick: handleClickShowPassword,
    onMouseDown: handleMouseDownPassword
  });
};

var _default = FormPasswordField;
exports.default = _default;